module.exports = __webpack_public_path__ + "static/img/cubo-icon.0091694.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/cubo-icon.png
// module id = 645
// module chunks = 1